export const cookies = undefined;
export const headers = undefined;
export const isReactServer = false;
